import React from 'react';
import ContainerProfile from './component/ContainerProfile';

export default function ProfilePassword() {
    return (
        <ContainerProfile>
            <div>
                <h4 className="text-2xl font-medium">Reset password</h4>
            </div>
        </ContainerProfile>
    );
}